import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { UOMLayout } from "../Layout";
function UOMTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='66561178-6140-4E9D-8692-5B2C00FC1121'
                layoutName='WMItemDataEntryUOMForm'
                defaultFormSchema={UOMLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.handleUOMFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UOMTab);